import React, { useContext } from 'react';
import styles from '../../css/functional.module.scss';
import SearchContext from '../data/FunnelbackContext';
import BestBetResult from './BestBetResult';
import GenericResult from './GenericResult';
import GridView from './GridView';
import ListView from './ListView';
import NoResults from './NoResults';

/**
 * Renders search results and handles logic related to them.
 *
 * @returns {JSX.Element}
 * @constructor
 */
function SearchResults() {
    const { isFetching, bestBets, results, resultsSummary, userDisplayMode } = useContext(SearchContext);

    if (isFetching) {
        return (
            <>
                <div className="sr-only">Loading...</div>
                {[...Array(5)].map((item, index) => (
                    <div
                        className="funnelback-instant-search-generic-result--loading"
                        // eslint-disable-next-line react/no-array-index-key
                        key={`result-${index}`}
                    />
                ))}
            </>
        );
    }

    if (bestBets.length === 0 && results.length === 0 && resultsSummary.query !== undefined) {
        return <NoResults />;
    }

    if (userDisplayMode === 'grid') {
        return (
            <div className={`${styles.gridView} funnelback-instant-search-grid-view`}>
                <ul>
                    {bestBets.map((item) => (
                        <li key={item.indexUrl}>
                            <BestBetResult userDisplayMode={userDisplayMode} {...item} />
                        </li>
                    ))}
                    {results.map((item) => (
                        <li key={item.indexUrl}>
                            <GridView {...item} />
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    if (userDisplayMode === 'list') {
        return (
            <div className={`${styles.listView} funnelback-instant-search-list-view`}>
                {bestBets.map((item) => (
                    <BestBetResult key={item.indexUrl} userDisplayMode={userDisplayMode} {...item} />
                ))}
                {results.map((item) => (
                    <ListView key={item.indexUrl} {...item} />
                ))}
            </div>
        );
    }

    return (
        bestBets.map((item) => <BestBetResult key={item.indexUrl} userDisplayMode={userDisplayMode} {...item} />) +
        results.map((item) => <GenericResult key={item.indexUrl} {...item} />)
    );
}

export default SearchResults;
